import { useSelector } from "react-redux";
import { selectWorldCupResult } from "./WorldCupResultSlice";
import { intArray } from "./utils";

export default function WorldCup16TeamsBracket(props) {
    const { width, height, xMargin, firstRoundYMargin } = { ...props };
    return <svg
        width={width * 16 + xMargin * 6}
        height={height * 8 + firstRoundYMargin * 3}
        style={{ margin: "auto", display: "block" }}
    >
        {RoundOf16Left(props)}
        {QuarterFinalsLeft(props)}
        {SemiFinalLeft(props)}
        {Finals(props)}
        {Winner(props)}
        {SemiFinalRight(props)}
        {QuarterFinalsRight(props)}
        {RoundOf16Right(props)}
    </svg>;
}

function LeftTeam(props) {
    const { code, x, y, width, height } = { ...props };
    return <g>
        {code && <image
            x={x}
            y={y}
            width={width}
            height={height}
            href={"https://api.fifa.com/api/v3/picture/flags-sq-1/" + code}
        />}
        {code && <text
            x={x + width * 1.5}
            y={y + height * 0.5}
            fill="white"
            fontFamily="monospace"
            fontSize="16px"
            fontWeight="bold"
            alignmentBaseline="middle"
            textAnchor="middle">
            {code}
        </text>}
        <rect
            x={x}
            y={y}
            width={width * 2}
            height={height}
            stroke="white"
            fillOpacity={0}
        />
    </g>;
}

function RightTeam(props) {
    const { code, x, y, width, height } = { ...props };
    return <g>
        {code && <text
            x={x + width * 0.5}
            y={y + height * 0.5}
            fill="white"
            fontFamily="monospace"
            fontSize="16px"
            fontWeight="bold"
            alignmentBaseline="middle"
            textAnchor="middle">
            {code}
        </text>}
        {code && <image
            x={x + width}
            y={y}
            width={width}
            height={height}
            href={"https://api.fifa.com/api/v3/picture/flags-sq-1/" + code}
        />}
        <rect
            x={x}
            y={y}
            width={width * 2}
            height={height}
            stroke="white"
            fillOpacity={0}
        />
    </g>;
}

function WinnerTeam(props) {

    const { code, x, y, width, height } = { ...props };
    return <g>
        {code && <image
            x={x}
            y={y}
            width={width * 2}
            height={height * 2}
            href={"https://api.fifa.com/api/v3/picture/flags-sq-3/" + code}
        />}
        {code && <text
            x={x + width}
            y={y + height * 3}
            fill="white"
            fontFamily="monospace"
            fontSize="32px"
            fontWeight="bold"
            alignmentBaseline="middle"
            textAnchor="middle">
            {code}
        </text>}
        <rect
            x={x}
            y={y}
            width={width * 2}
            height={height * 4}
            stroke="white"
            fillOpacity={0}
        />
    </g>;
}

function RoundOf16Left(props) {
    const { width, height, xMargin, firstRoundYMargin } = { ...props };
    const result = useSelector(selectWorldCupResult);
    const x = 0;
    const y = 0;
    const yMargin = firstRoundYMargin;
    return <g>
        {intArray(4).slice(0, 4).map(i => {
            let team1, team2;
            if (result.roundOf16 && result.roundOf16[i]) {
                team1 = result.roundOf16[i].team1;
                team2 = result.roundOf16[i].team2;
            }
            return <g key={i}>
                <LeftTeam
                    code={team1}
                    x={x}
                    y={height * i * 2 + yMargin * i}
                    width={width}
                    height={height}
                />
                <LeftTeam
                    code={team2}
                    x={x}
                    y={height * (i * 2 + 1) + yMargin * i}
                    width={width}
                    height={height}
                />
            </g>;
        })}
        {intArray(2).map(i => <g key={i}>
            <line x1={x + width * 2} y1={y + height + (height * 4 + yMargin * 2) * i} x2={x + width * 2 + xMargin * 0.5} y2={y + height + (height * 4 + yMargin * 2) * i} stroke="white" />
            <line x1={x + width * 2} y1={y + height * 3 + yMargin + (height * 4 + yMargin * 2) * i} x2={x + width * 2 + xMargin * 0.5} y2={y + height * 3 + yMargin + (height * 4 + yMargin * 2) * i} stroke="white" />
            <line x1={x + width * 2 + xMargin * 0.5} y1={y + height + (height * 4 + yMargin * 2) * i} x2={x + width * 2 + xMargin * 0.5} y2={y + height * 3 + yMargin + (height * 4 + yMargin * 2) * i} stroke="white" />
            <line x1={x + width * 2 + xMargin * 0.5} y1={y + height * 2 + yMargin * 0.5 + (height * 4 + yMargin * 2) * i} x2={x + width * 2 + xMargin} y2={y + height * 2 + yMargin * 0.5 + (height * 4 + yMargin * 2) * i} stroke="white" />
        </g>
        )}
    </g>;
}

function QuarterFinalsLeft(props) {
    const { width, height, xMargin, firstRoundYMargin } = { ...props };
    const result = useSelector(selectWorldCupResult);
    const x = width * 2 + xMargin;
    const y = height + firstRoundYMargin * 0.5;
    const yMargin = height * 2 + firstRoundYMargin * 2;
    return <g>
        {intArray(2).map(i => {
            let team1, team2;
            if (result.quarterFinals && result.quarterFinals[i]) {
                team1 = result.quarterFinals[i].team1;
                team2 = result.quarterFinals[i].team2;
            }
            return <g key={i}>
                <LeftTeam
                    code={team1}
                    x={x}
                    y={y + height * i * 2 + yMargin * i}
                    width={width}
                    height={height}
                />
                <LeftTeam
                    code={team2}
                    x={x}
                    y={y + height * (i * 2 + 1) + yMargin * i}
                    width={width}
                    height={height}
                />
                <line x1={x + width * 2} y1={y + height} x2={x + width * 2 + xMargin * 0.5} y2={y + height} stroke="white" />
                <line x1={x + width * 2} y1={y + height * 3 + yMargin} x2={x + width * 2 + xMargin * 0.5} y2={y + height * 3 + yMargin} stroke="white" />
                <line x1={x + width * 2 + xMargin * 0.5} y1={y + height} x2={x + width * 2 + xMargin * 0.5} y2={y + height * 3 + yMargin} stroke="white" />
                <line x1={x + width * 2 + xMargin * 0.5} y1={y + height * 2 + yMargin * 0.5} x2={x + width * 2 + xMargin} y2={y + height * 2 + yMargin * 0.5} stroke="white" />
            </g>;
        })}
    </g>;
}

function SemiFinalLeft(props) {
    const { width, height, xMargin, firstRoundYMargin } = { ...props };
    const result = useSelector(selectWorldCupResult);
    const x = width * 4 + xMargin * 2;
    const y = height * 3 + firstRoundYMargin * 1.5;
    let team1, team2;
    if (result.semiFinals && result.semiFinals[0]) {
        team1 = result.semiFinals[0].team1;
        team2 = result.semiFinals[0].team2;
    }
    return <g>
        <LeftTeam
            code={team1}
            x={x}
            y={y}
            width={width}
            height={height}
        />
        <LeftTeam
            code={team2}
            x={x}
            y={y + height}
            width={width}
            height={height}
        />
        <line x1={x + width * 2} y1={y + height} x2={x + width * 2 + xMargin} y2={y + height} stroke="white" />
    </g>;
}

function Finals(props) {
    const { width, height, xMargin, firstRoundYMargin } = { ...props };
    const result = useSelector(selectWorldCupResult);
    const finals = result.finals;
    const x = width * 6 + xMargin * 3;
    const y = height * 3 + firstRoundYMargin * 2;
    return <g>
        <LeftTeam
            code={finals?.team1}
            x={x}
            y={y}
            width={width}
            height={height}
        />
        <RightTeam
            code={finals?.team2}
            x={x + width * 2}
            y={y}
            width={width}
            height={height}
        />
    </g>;
}

function Winner(props) {
    const { width, height, xMargin } = { ...props };
    const result = useSelector(selectWorldCupResult);
    let code;
    if (Number.isInteger(result.finals?.goal1) && Number.isInteger(result.finals?.goal2)) {
        const goal1 = result.finals.goal1;
        const goal2 = result.finals.goal2;
        const psoWinner = result.finals.psoWinner;
        if (goal1 > goal2) {
            code = result.finals.team1;
        } else if (goal2 > goal1) {
            code = result.finals.team2;
        } else if (psoWinner === 1) {
            code = result.finals.team1;
        } else if (psoWinner === 2) {
            code = result.finals.team2;
        }
    }
    const x = width * 7 + xMargin * 3;
    const y = 0;
    return <WinnerTeam code={code} x={x} y={y} width={width} height={height} />;
}

function SemiFinalRight(props) {
    const { width, height, xMargin, firstRoundYMargin } = { ...props };
    const result = useSelector(selectWorldCupResult);
    let team1, team2;
    if (result.semiFinals && result.semiFinals[1]) {
        team1 = result.semiFinals[1].team1;
        team2 = result.semiFinals[1].team2;
    }
    const x = width * 10 + xMargin * 4;
    const y = height * 3 + firstRoundYMargin * 1.5;
    return <g>
        <RightTeam
            code={team1}
            x={x}
            y={y}
            width={width}
            height={height}
        />
        <RightTeam
            code={team2}
            x={x}
            y={y + height}
            width={width}
            height={height}
        />
        <line x1={x} y1={y + height} x2={x - xMargin} y2={y + height} stroke="white" />
    </g>;
}

function QuarterFinalsRight(props) {
    const { width, height, xMargin, firstRoundYMargin } = { ...props };
    const result = useSelector(selectWorldCupResult);
    const x = width * 12 + xMargin * 5;
    const y = height + firstRoundYMargin * 0.5;
    const yMargin = height * 2 + firstRoundYMargin * 2;
    return <g>
        {intArray(2).map(i => {
            let team1, team2;
            if (result.quarterFinals && result.quarterFinals[i + 2]) {
                team1 = result.quarterFinals[i + 2].team1;
                team2 = result.quarterFinals[i + 2].team2;
            }
            return <g key={i}>
                <RightTeam
                    code={team1}
                    x={x}
                    y={y + height * i * 2 + yMargin * i}
                    width={width}
                    height={height}
                />
                <RightTeam
                    code={team2}
                    x={x}
                    y={y + height * (i * 2 + 1) + yMargin * i}
                    width={width}
                    height={height}
                />
                <line x1={x} y1={y + height} x2={x - xMargin * 0.5} y2={y + height} stroke="white" />
                <line x1={x} y1={y + height * 3 + yMargin} x2={x - xMargin * 0.5} y2={y + height * 3 + yMargin} stroke="white" />
                <line x1={x - xMargin * 0.5} y1={y + height} x2={x - xMargin * 0.5} y2={y + height * 3 + yMargin} stroke="white" />
                <line x1={x - xMargin * 0.5} y1={y + height * 2 + yMargin * 0.5} x2={x - xMargin} y2={y + height * 2 + yMargin * 0.5} stroke="white" />
            </g>;
        })}
    </g>;
}

function RoundOf16Right(props) {
    const { width, height, xMargin, firstRoundYMargin } = { ...props };
    const result = useSelector(selectWorldCupResult);
    const x = width * 14 + xMargin * 6;
    const y = 0;
    const yMargin = firstRoundYMargin;
    return <g>
        {intArray(4).map(i => {
            let team1, team2;
            if (result.roundOf16 && result.roundOf16[i + 4]) {
                team1 = result.roundOf16[i + 4].team1;
                team2 = result.roundOf16[i + 4].team2;
            }
            return <g key={i}>
                <RightTeam
                    code={team1}
                    x={x}
                    y={y + height * i * 2 + yMargin * i}
                    width={width}
                    height={height}
                />
                <RightTeam
                    code={team2}
                    x={x}
                    y={y + height * (i * 2 + 1) + yMargin * i}
                    width={width}
                    height={height}
                />
            </g>;
        })}
        {intArray(2).map(i => <g key={i}>
            <line x1={x} y1={y + height + (height * 4 + yMargin * 2) * i} x2={x - xMargin * 0.5} y2={y + height + (height * 4 + yMargin * 2) * i} stroke="white" />
            <line x1={x} y1={y + height * 3 + yMargin + (height * 4 + yMargin * 2) * i} x2={x - xMargin * 0.5} y2={y + height * 3 + yMargin + (height * 4 + yMargin * 2) * i} stroke="white" />
            <line x1={x - xMargin * 0.5} y1={y + height + (height * 4 + yMargin * 2) * i} x2={x - xMargin * 0.5} y2={y + height * 3 + yMargin + (height * 4 + yMargin * 2) * i} stroke="white" />
            <line x1={x - xMargin * 0.5} y1={y + height * 2 + yMargin * 0.5 + (height * 4 + yMargin * 2) * i} x2={x - xMargin} y2={y + height * 2 + yMargin * 0.5 + (height * 4 + yMargin * 2) * i} stroke="white" />
        </g>
        )}
    </g>;
}